<template>
  <div>
    <div class="max-height"
         :class="{'open-images-modal': showPagination}"
         @mouseenter="slideNext()"
         @mouseover="playSlides()"
         @mouseleave="stopSlides()">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide
          data-swiper-autoplay="1500"
          :class="{'swiper-slide-active': index == 0}"
          v-for="(image, index) in images" :key="index">
          <img @click="showModal()" :src="image" alt="">
        </swiper-slide>

        <div v-if="showPagination" class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper';
  // import 'swiper/dist/css/swiper.css';

  export default {
    components: {
      swiper,
      swiperSlide,
    },

    props: {
      images: {
        type: undefined
      },

      showPagination: {
        default: true,
      }
    },

    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      }
    },

    data() {
      return {
        swiperOption: {
          effect: 'fade',
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet(index, className) {
              return `<span class="${className} swiper-pagination-bullet-custom"></span>`
            }
          }
        },
      }
    },
    methods: {
      slideNext() {
        if (!this.showPagination) {
          this.swiper.slideNext(300, false);
        }
      },

      playSlides() {
        if (!this.showPagination) {
          this.swiper.autoplay.start()
        }
      },

      stopSlides() {
        if (!this.showPagination) {
          this.swiper.autoplay.stop();
          this.swiper.slideTo(0);
        }
      },

      showModal() {
        if (this.showPagination)
          this.$root.$emit('show-product-images-modal', this.images);
      }
    }
  }
</script>
<style>
  .swiper-container {
    overflow: visible;
  }

  .swiper-slide img {
    max-width: 100%;
    vertical-align: middle;
    display: table-cell;
    margin: 0 auto;
  }

  @media screen and (max-width: 768px) {
    .swiper-slide img {
      position: relative;
      max-width: 100%;
      max-height: 298px;
    }
  }

  .swiper-container .swiper-slide {
    line-height: 300px;
    display: table;
  }

  .max-height {
    height: 100%;
  }

  .open-images-modal {
    cursor: pointer;
  }

  .swiper-pagination-bullet-active {
    background: #ED1763;
  }

  .swiper-pagination {
    margin-top: 10px;
    position: unset;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
  }

  .swiper-pagination-bullet-custom:hover {
    border: 2px solid #000;
    background: #ED1763;
    opacity: 1;
  }

  .swiper-slide:not([class*="active"]) {
    opacity: 0 !important;
  }
</style>




// WEBPACK FOOTER //
// resources/assets/js/store/components/TemplateCarousel.vue